import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const GuidedTourActions = createActionGroup({
  source: 'Guided Tour',
  events: {
    'Load Guided Tour Notifications': emptyProps(),
    'Dismiss Guided Tour Notification': emptyProps(),
    'Set Guided Tour Loading': props<{ loading: boolean }>(),
  },
});

export const GuidedTourApiActions = createActionGroup({
  source: 'Guided Tour API',
  events: {
    'Load Guided Tour Notifications Success': props<{ showNotification: boolean }>(),
    'Load Guided Tour Notifications Failure': props<{ error: HttpErrorResponse }>(),
    'Dismiss Guided Tour Notification Success': emptyProps(),
    'Dismiss Guided Tour Notification Failure': props<{ error: HttpErrorResponse }>(),
  },
});
